/* eslint-disable no-inner-declarations */
/**
 * External Dependencies
 */
import 'jquery';
import 'bootstrap';
// import * as bootstrap from 'bootstrap';
import './contrast';
import './members-directory';
import './directory';
import 'jquery-hammerjs/jquery.hammer';
import { gsap } from "gsap";
import './postsslider';

$(() => {
  // console.log('Hello world');

  const app = document.getElementById("app");
  //Scroll to top
  $('.page-top').on('click', function (){
    app.scrollIntoView({behavior: 'smooth'});
  });

  const $pageTopFloating = $('.page-top.floating');
  const showPageTopFloating = () => {
    $pageTopFloating.addClass('show');
  }
  const hidePageTopFloating = () => {
    $pageTopFloating.removeClass('show');
  }

  $(window).on('scroll', function(){
    if ($(this).scrollTop() > 400) {
      showPageTopFloating();
    } else {
      hidePageTopFloating();
    }
  });

  $('.w3-contrast').highContrast();

  // Create Posts sliders on the page
  const $posts = $('.posts-slider-block');
  if ($posts.length) {
    $posts.postsSlider(true, gsap);
  }

  const myCollapsible = document.getElementById('collapseSearch')
  myCollapsible.addEventListener('shown.bs.collapse', function () {
    $('#collapseSearch .search-field').trigger('focus');
  })

  // const tabEl = document.querySelector('button[data-bs-toggle="tab"]')
  //Init calendar and preselect category
  const tabCalendar = document.getElementById('nav-calendar-tab')
  if (tabCalendar) {
      tabCalendar.addEventListener('shown.bs.tab', function () {
      // event.target // newly activated tab
      // event.relatedTarget // previous active tab

    $('.eo-fullcalendar').fullCalendar('render');
     const pathArray = location.pathname.split('/');

	const i = pathArray.indexOf('category');
	if (i > -1) {
		const cat = pathArray[i+1];
		if (cat) $('.eo-fc-filter-category').val(cat);
	}
   })
  }



  if ($('#registerCaptcha').length) {

    // eslint-disable-next-line no-unused-vars
    const doneCallback = (solution) => {
      // console.log("CAPTCHA completed succesfully, solution:", solution);
      //Enable the button
      $('#registerSubmit').removeAttr('disabled').removeAttr('aria-disabled').removeClass('disabled');
      //Add the action to the form
      const $form = $('#registerForm');
      const action = $form.data('action');
      $form.attr('action', action);
    }


    // eslint-disable-next-line no-unused-vars
    const errorCallback = (err) => {
      console.log('There was an error when trying to solve the Captcha.');
      // console.log(err);
    }


    let i = 0;
    setTimeout(function fc() {
      //Check for friendlyChallenge
      if (i > 1 &&!window.friendlyChallenge ) {
          i++;
          setTimeout(fc, 500);
          return;
        }
        // To get the widget that was created on script load (null if no widget instance was created)
        const defaultWidget = window.friendlyChallenge.autoWidget;
        // console.log('defaultWidget', defaultWidget);
        if (!defaultWidget) {
          return;
        }

        defaultWidget.opts.doneCallback = doneCallback;
        defaultWidget.opts.errorCallback = errorCallback;

      }, 500);
    }

    //Stop carousel video on slide
    const $featureCarousel = $('#featureCarouselHeader');
    if ($featureCarousel.length) {
      $featureCarousel.on('slide.bs.carousel', function () {
        const $video = $(this).find('.carousel-item.active iframe');
        if ($video.length) {
          const src = $video.prop('src');
          $video.prop('src', src);
        }

        document.getElementById('featureCarouselHeader').scrollIntoView();
      });
    }

    // INITIATE DIRECTORY
  // Check for apiObj
  // eslint-disable-next-line no-undef
  if (typeof apiObj != 'undefined' && apiObj) {
    // eslint-disable-next-line no-undef
    // console.log('apiObj', apiObj);
    const $entriesContainer = $('#entriesContainer');

    // Check if the page / post has #entriesContainer
    if ($entriesContainer.length) {
      const $filterItem = $('#offcanvasFilterssNavbar .nav-link:not(.toggle)');

      const attr = {
        // eslint-disable-next-line no-undef
        'api_url': apiObj.api_url,
        'post_type': $entriesContainer.data('post_type'),
        'default_terms': $entriesContainer.data('terms'),
        'posts_per_page': $entriesContainer.data('posts_per_page'),
        'filter_item': $filterItem,
        // eslint-disable-next-line no-undef
        'area': apiObj.area,
      }

      //Initiate the directory object
      $entriesContainer.directory(attr);

    }
  }


});
